import { useEffect } from "react";

const raw = new Intl.DateTimeFormat("it-IT", { month: "long", year: "numeric" }).format(new Date());
export const MESE_ANNO = raw.charAt(0).toUpperCase() + raw.slice(1);

const fill = (s = "") => s.replaceAll("{Mese Anno}", MESE_ANNO);

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const SITE_URL = "https://xmoveitalia.com";

export function useSeo({ title, description, path, jsonLd, image, type = "website", noindex = false }) {
  useEffect(() => {
    const t = fill(title);
    const d = fill(description);
    const url = `${SITE_URL}${path}`;
    document.title = t;
    upsertMeta("name", "description", d);
    upsertMeta("name", "robots", noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1");
    upsertMeta("property", "og:title", t);
    upsertMeta("property", "og:description", d);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:site_name", "XMOVE Italia");
    upsertMeta("property", "og:locale", "it_IT");
    upsertMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    upsertMeta("name", "twitter:title", t);
    upsertMeta("name", "twitter:description", d);
    if (image) {
      upsertMeta("property", "og:image", image);
      upsertMeta("name", "twitter:image", image);
    } else {
      document.head.querySelectorAll('meta[property="og:image"], meta[name="twitter:image"]').forEach((el) => el.remove());
    }

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    const scripts = [];
    (Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : []).forEach((schema) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.dataset.xmoveSeo = "true";
      s.textContent = JSON.stringify(schema);
      document.head.appendChild(s);
      scripts.push(s);
    });
    return () => scripts.forEach((s) => s.remove());
  }, [title, description, path, jsonLd, image, type, noindex]);
}

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "XMOVE Italia",
  alternateName: ["XMOVE", "xmoveitalia.com"],
  url: SITE_URL,
  telephone: "+393793792323",
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "5.0",
    reviewCount: "21",
  },
};
